import { datadogLogs } from '@datadog/browser-logs';
import is from '@sindresorhus/is';
import { HTTPError } from 'ky';

import type { ErrorReporter } from '~/shared/validating-http-fetcher/validating-http-fetcher';

export const initDataDog = (): ErrorReporter => {
    datadogLogs.init({
        beforeSend: (event) => {
            if (is.undefined(event.error) === false && Boolean(event.error.stack?.startsWith('AbortError:'))) {
                return false;
            }

            if (event.http?.status_code === 0) {
                return false;
            }

            return true;
        },
        clientToken: 'pubb709d48d6e6fd56a010dda5934c4be1d',
        env: import.meta.env.PROD === true ? 'prod' : 'dev',
        forwardConsoleLogs: ['error'],
        forwardErrorsToLogs: true,
        proxy: 'https://privacy.fe.cobrainer.cloud/logs/',
        service: 'frontend',
        sessionSampleRate: 100,
        site: 'datadoghq.eu',
        version: import.meta.env.APP_VERSION,
    });

    datadogLogs.setGlobalContextProperty('tenant_hostnameSlug', globalThis.location.hostname);

    return {
        reportError: (message, error) => {
            if (error instanceof HTTPError) {
                datadogLogs.logger.error(
                    message,
                    {
                        http: {
                            method: error.request.method,
                            status_code: error.response.status,
                            url: error.request.url.toString(),
                        },
                    },
                    error,
                );
            } else {
                datadogLogs.logger.error(message, undefined, error);
            }
        },
    };
};

export const setDatadogTenantId = (tenantId: string): void => {
    datadogLogs.setGlobalContextProperty('tenant_id', tenantId);
};
